import { storeApi } from '@shared/config/axios';

export default {
  getCalendarEvents(params) {
    return storeApi.$get('/customers/me/calendar_events', { params });
  },
  getCalendarEvent(uuid) {
    return storeApi.$get(`/customers/me/calendar_events/${uuid}`);
  },
  getCalendar(params) {
    return storeApi.$get('/customers/me/calendar', { params });
  },
};
